import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

import Task = gapi.client.tasks.Task;

const DEBUG = false;

@Component({
  selector: 'app-tasks-item',
  templateUrl: './tasks-item.component.html',
  styleUrls: ['./tasks-item.component.scss']
})
export class TasksItemComponent {

  @Input() task!: Task; // eslint-disable-line @typescript-eslint/no-non-null-assertion
  @Output() deleted = new EventEmitter<Task>();
  @Output() undeleted = new EventEmitter<Task>();
  @Output() completed = new EventEmitter<Task>();

  constructor() {
    if (DEBUG) console.log('new TasksItemComponent()');
  }

  toggleCompleted(change: MatCheckboxChange): void {
    this.task.status = change.checked ? 'completed' : 'needsAction';
    this.completed.emit(this.task);
  }

  delete(): void {
    this.deleted.emit(this.task);
  }

  undelete(): void {
    this.undeleted.emit(this.task);
  }

  calculateAriaChecked(): string {
    // console.error('TODO: Implement calculateAriaChecked()');
    return this.task.completed ? 'true' : 'false';
  }

  isComplete(): boolean {
    return this.task.completed ? true : false;
  }

  isIndeterminate(): boolean {
    // console.error('TODO: Implement isIndeterminate based on steps');
    return /mixed/.exec(this.calculateAriaChecked()) ? true : false;
  }
}
